import { useEffect, useState } from 'react';
import { PersonaLabel, SuiteId } from '~/interfaces';
import { get } from '~/utils';
import { fetchPersonaLabel } from '~/request/persona';

const usePersonaLabel = (options?: { enabled?: boolean; suiteId: SuiteId }) => {
    const { enabled = true, suiteId } = options || {};

    const [personaLabel, setPersonaLabel] = useState<PersonaLabel>();

    useEffect(() => {
        if (!enabled) {
            return;
        }
        fetchPersonaLabel(suiteId).then((res) => {
            setPersonaLabel(get(res, 'data'));
        });
    }, [enabled, suiteId]);

    return personaLabel;
};

export default usePersonaLabel;
